import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MenuSheet } from "../components/MenuSheet";
import { PRICE_NOTE } from "../data/site";

export const MenuPreview = () => (
  <section data-testid="menu-preview-section" className="bg-canvas-subtle py-16 sm:py-24">
    <div className="mx-auto max-w-6xl px-5">
      <div className="flex flex-wrap items-end justify-between gap-6">
        <div className="max-w-xl">
          <p className="font-mono text-xs font-bold uppercase tracking-[0.25em] text-bumbu">
            Menu Andalan
          </p>
          <h2 className="mt-3 font-heading text-3xl font-extrabold tracking-tight text-charcoal sm:text-4xl">
            Sedikit menunya, serius rasanya.
          </h2>
          <p className="mt-4 text-base leading-relaxed text-charcoal-muted">
            Bu Iyin fokus pada satu keahlian: ayam goreng basah khas Bandung,
            ditemani pelengkap yang sama khasnya.
          </p>
        </div>
        <Link
          to="/menu/"
          data-testid="menu-preview-cta"
          className="inline-flex items-center gap-2 font-heading text-sm font-bold text-bawang transition-colors hover:text-bawang-dark"
        >
          Lihat menu lengkap
          <ArrowRight className="h-4 w-4" aria-hidden="true" />
        </Link>
      </div>

      <div className="mx-auto mt-12 max-w-3xl">
        <MenuSheet />
        <p className="mt-6 text-center text-xs leading-relaxed text-charcoal-muted">
          {PRICE_NOTE}
        </p>
      </div>
    </div>
  </section>
);
